import {cashBoxHeaderFilter} from "../../../hoc/cashBoxHeaderFilter";
import CashBoxExpenseRegister from "./CashBoxExpenseRegister";

const CashBoxExpenseDataTableHeader = cashBoxHeaderFilter(CashBoxExpenseRegister, 'CashBoxExpenseHeaderFilter')

export default CashBoxExpenseDataTableHeader
